import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  // Dashboard filters
  const [dashboardFilters, setDashboardFilters] = useState({
    selectedCategories: [],
    startDate: null,
    endDate: null
  });

  // High Value filters
  const [highValueFilters, setHighValueFilters] = useState({
    selectedCategories: [],
    startDate: null,
    endDate: null
  });

  // Reset dashboard filters
  const resetDashboardFilters = () => {
    setDashboardFilters({
      selectedCategories: [],
      startDate: null,
      endDate: null
    });
  };

  // Reset high value filters
  const resetHighValueFilters = () => {
    setHighValueFilters({
      selectedCategories: [],
      startDate: null,
      endDate: null
    });
  };

  // Reset all filters
  const resetAllFilters = () => {
    resetDashboardFilters();
    resetHighValueFilters();
  };

  return (
    <FilterContext.Provider value={{
      dashboardFilters,
      setDashboardFilters,
      resetDashboardFilters,
      highValueFilters,
      setHighValueFilters,
      resetHighValueFilters,
      resetAllFilters
    }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
};
